export default __webpack_public_path__ + "vendor/stylesheets/ng-table.min.css";